export function truncateMiddle(
  value: string,
  startChars: number,
  endChars: number,
): string {
  if (!value) return '';

  const minLength = startChars + endChars;

  if (value.length <= minLength) {
    return value;
  }

  const start = value.slice(0, startChars);
  const end = value.slice(-endChars);

  return `${start}...${end}`;
}
